import type {DOMAIN_ENUM} from './enumMap';

export const DATA_TYPE = {
    NUMBER: "NUMBER",
    TEXT: "TEXT",
    DATA: "DATA",
    DATE: "DATE",
    BOOLEAN: "BOOLEAN",
    ENUM: "ENUM",
    ARRAY: "ARRAY"
} as const;

export const COMMUNICATION_FORMAT = {
    DATE: "YYYYMMDD",
    TIME: null,
} as const;

export const DATA_FORMAT = {
    YYYYMMDD: "YYYY. MM. DD",
    YYYYMMDD_HHmm: "YYYY. MM. DD<i>HH:mm</i>",
} as const;

export const DOMAIN_MAX_LENGTH = {
    ID: 36,
    PASSWORD: 500,
    CODE: 100,
    NAME: 100,
    NUMBER: 100,
    EMAIL: 320,
    PHONE: 100,
    CELL_PHONE: 11,
    ADDRESS: 500,
    DEPARTMENTS: 500,
    AUTH_ID: 320,
    REMARK: 500,
    MESSAGE: 500,
    DESCRIPTION: 500,
    FILE_PATH: 500,
    FILE_HASH: 500,
    FILE_FORMAT: 500,
    KEY: 50,
    VALUE: 500,
    URL: 500,
    COLOR: 10,
    IP: 200,
    USER_AGENT: 500,
    DATE: 8,
    TOKEN: 500,
    EXTERNAL_ID: 500,
    EXTERNAL_STATE_ID: 500,
    EXTERNAL_STATE_NAME: 50,
} as const;

// ============================================
// 스키마 정의 계약
// ============================================

/** enumMap 에 등록된 enum 이름 */
type MappedEnumName = keyof typeof DOMAIN_ENUM;

/** FE 가상 enum */
type FeOnlyEnumName =
    | 'LabelDocumentType'
    | 'LabelApprovalRequestReason'
    | 'DocumentDepartmentReferenceType';

type SchemaEnumName = MappedEnumName | FeOnlyEnumName;

/** 표시 형식이 붙을 수 있는 필드의 공통 속성 */
type Formatted = {
    format?: (typeof DATA_FORMAT)[keyof typeof DATA_FORMAT];
    communication?: (typeof COMMUNICATION_FORMAT)[keyof typeof COMMUNICATION_FORMAT];
    maxLength?: number;
};

/** 스키마 필드 */
export type SchemaField =
    | ({type: typeof DATA_TYPE.TEXT; value: string | null} & Formatted)
    | ({type: typeof DATA_TYPE.DATE; value: string | null} & Formatted)
    | {type: typeof DATA_TYPE.NUMBER; value: number | null}
    | {type: typeof DATA_TYPE.BOOLEAN; value: boolean | null}
    | {type: typeof DATA_TYPE.ENUM; enum: SchemaEnumName; value: string | null}
    | {type: typeof DATA_TYPE.ARRAY; value: readonly unknown[] | null}
    | {type: typeof DATA_TYPE.DATA; value: object | null};

/** 도메인 스키마 전체 — `<도메인>: {<필드>: SchemaField}` */
export type DomainSchemaDefinition = Record<string, Record<string, SchemaField>>;
